<template>
  <div>
     <div id="arcssd" style="display:none;text-align:center;background-color:#007bff;font-weight:500;color:white;"> Share Currently Inactive </div>
     <img id="arcss0" style="position:absolute;width:100%;" > </img>
     <img id="arcss1" style="position:absolute;width:100%;"> </img>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";

export default {
  name: "archss",
  data(){
    return {
      cnt:0,
      tid:null,
      cur_ssat: null,
      userid:"",
      ssurlbase:"",
    };
  },
  components: {
  },
  created() {
    let vue = this;
    console.log(vue.$router.currentRoute.params.acc);
    console.log(vue.$router.currentRoute.params.uid);
    console.log(vue.$router.currentRoute.params.handle);
    vue.userid = vue.$router.currentRoute.params.userid;
    vue.ssurlbase = getLocal("arcurl") + "/" + vue.userid + "/";
    console.log(vue.ssurlbase);
    if (vue.tid) {    
    }
    window.setTimeout(vue.update, 500);
  },
  methods: {
    update: function() {
       let vue = this;
       let ssat = getLocal("arcssat");
       let cnt = vue.cnt;
       if (ssat && ssat != vue.cur_ssat) {
          let url = vue.ssurlbase + ssat + ".png";
          console.log("Load:"+url);
          vue.cur_ssat = ssat;
          let $img = $("#arcss"+cnt);
          $img.one("load", function() {
            console.log("loaded"+cnt);
            if (cnt) { vue.cnt = 0; } else { vue.cnt = 1; }
            $("#arcssd").hide();
            $img.show();
            $img.css("z-index","10000");
            $("#arcss"+vue.cnt).css("z-index","1");
          });
          $img.one("error", function() {
            console.log("error"+cnt);
            $img.hide();
            $("#arcssd").show();
          });
          $img[0].src = url;
       }
       window.setTimeout(vue.update, 500);
    },
  },
  computed: {
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 760px;
}
</style>
